import { _ep0, _mw0, command } from "../commandBuilder";
import { ListBaptism$ } from "../schemas/schemas_0";
export class ListBaptismCommand extends command(_ep0, _mw0, "ListBaptism", ListBaptism$) {
}
